import React from 'react';

import { useIntl } from 'react-intl';
import { View } from 'react-native';

import ActionButton, { ActionButtonSizes } from 'components/action-button';
import { ClickEventComponentNames } from 'state/amplitude';
import { useCartContext } from 'state/cart';

import { useCheckoutContext } from '../../checkout-provider';
import { useCheckoutLoadingState } from '../../hooks';
import { useCheckoutSubmit } from '../../hooks/use-checkout-submit';
import { useCheckoutValidation } from '../../hooks/use-checkout-validation';

export const PlaceOrderButton = () => {
  const { formatMessage } = useIntl();
  const { submitOrder, ErrorDialog } = useCheckoutSubmit();
  const { validate } = useCheckoutValidation();
  const checkoutErrors = validate();
  const [, setCheckoutState] = useCheckoutContext();
  const { isCheckoutLoading } = useCheckoutLoadingState();
  const hasFooterErrors = checkoutErrors.some(error => error.placement === 'footer');
  const { isOrderPricingRetryInProgress } = useCartContext();

  const handlePress = () => {
    if (checkoutErrors.length === 0) {
      submitOrder();
    }
    const dialogErrors = checkoutErrors.filter(error => error.placement === 'errorDialog');
    if (dialogErrors.length > 0) {
      // TODO: we may need to rethink this if we want take different actions based on error type
      setCheckoutState(prev => ({ ...prev, errorModalOpen: true }));
    }
  };

  let buttonText = formatMessage({ id: 'placeOrder' });

  if (isOrderPricingRetryInProgress) {
    buttonText = formatMessage({ id: 'thisMayTakeAFewSeconds' });
  } else if (isCheckoutLoading) {
    buttonText = formatMessage({
      id: 'placingOrderCheckoutBtn',
      defaultMessage: 'Placing Order',
    });
  }

  return (
    <>
      <View style={{ width: '100%', padding: 16 }}>
        <ActionButton
          onPress={handlePress}
          disabled={isCheckoutLoading || hasFooterErrors}
          size={ActionButtonSizes.LARGE}
          isLoading={isCheckoutLoading}
          fullWidth
          eventAttributes={{
            component: ClickEventComponentNames.BUTTON,
            name: 'Place Secure Order',
          }}
        >
          {buttonText}
        </ActionButton>
      </View>

      <ErrorDialog />
    </>
  );
};
